import type {TravelType} from '@/modules/common/context/QueryParams/models';
import type {Page} from '@/types';

import {PAGE_HOTELS, PAGE_OFFERS} from '@/consts';
import {TravelTypes} from '@/modules/common/context/QueryParams/models';

export const buildVirtPath = ({
  page,
  travelType,
  noOffer,
}: {
  page: Page;
  travelType: TravelType;
  noOffer?: boolean;
}): string => {
  const portalString = {
    'aidu-de': 'AiduDe',
    'aidu-at': 'AiduAt',
    'aidu-ch': 'AiduCh',
    'invia-cz': 'AiduCz',
    'invia-sk': 'AiduSk',
    'invia-hu': 'AiduHu',
    'travelplanet-pl': 'AiduPl',
    'reisegeier-at': 'ReisegeierAt',
    'reisegeier-ch': 'ReisegeierCh',
    'reisegeier-de': 'ReisegeierDe',
    'reisen-de': 'ReisenDe',
    'reisen-fluege-de': 'ReisenFluegeDe',
  }[import.meta.env.VITE_PORTAL];

  // @TODO use consts
  const pageString = {
    [PAGE_HOTELS]: 'hotellist',
    [PAGE_OFFERS]: 'offerlist',
  }[page];
  const travelTypeString = {
    [TravelTypes.packageTour]: 'travelpackage',
    [TravelTypes.ownArrival]: 'ownarrival',
  }[travelType];

  return `/${portalString}/Bali/${pageString}/${
    noOffer ? 'nooffer/' : ''
  }${travelTypeString}`;
};
